var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("css")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("w-textarea-autogrow", {
                    model: {
                      value: _vm.value.CustomCss,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "CustomCss", $$v)
                      },
                      expression: "value.CustomCss",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }